/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrepareGeneralImportDto
 */
export interface PrepareGeneralImportDto {
    /**
     * XLSX file content as base64 string
     * @type {string}
     * @memberof PrepareGeneralImportDto
     */
    fileContent: string;
    /**
     * Client ID
     * @type {string}
     * @memberof PrepareGeneralImportDto
     */
    clientId: string;
}

/**
 * Check if a given object implements the PrepareGeneralImportDto interface.
 */
export function instanceOfPrepareGeneralImportDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileContent" in value;
    isInstance = isInstance && "clientId" in value;

    return isInstance;
}

export function PrepareGeneralImportDtoFromJSON(json: any): PrepareGeneralImportDto {
    return PrepareGeneralImportDtoFromJSONTyped(json, false);
}

export function PrepareGeneralImportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrepareGeneralImportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileContent': json['fileContent'],
        'clientId': json['clientId'],
    };
}

export function PrepareGeneralImportDtoToJSON(value?: PrepareGeneralImportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileContent': value.fileContent,
        'clientId': value.clientId,
    };
}

